import React, { forwardRef } from 'react';
import { string, bool, func } from 'prop-types';
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Button
} from '@mui/material';

import { DISPUTES_ACTIONS } from './utils';

const DisputeActionOptions = forwardRef(
  (
    {
      selectAction,
      setSelectAction,
      showMessageOption,
      showReOpenOption,
      showCloseAndCancelOption,
      openTermsAndConditions
    },
    messageRef
  ) => (
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label">
        <Typography variant="h6">Actions on Selected</Typography>
      </FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={selectAction}
        name="radio-buttons-group"
        onChange={event => setSelectAction(event.target.value)}
      >
        {showMessageOption && (
          <>
            <FormControlLabel
              value={DISPUTES_ACTIONS.SEND}
              control={<Radio size="small" />}
              label="Send Buyers a Message"
            />
            <Box ml={3}>
              <TextField
                inputRef={messageRef}
                className="buyer-message-text"
                id="outlined-textarea"
                multiline
                rows={5}
                variant="standard"
                placeholder="Please write your message here."
                InputLabelProps={{
                  shrink: true
                }}
              />
            </Box>
            {showCloseAndCancelOption && (
              <>
                <FormControlLabel
                  sx={{ mt: 1 }}
                  value={DISPUTES_ACTIONS.CANCEL}
                  control={<Radio size="small" />}
                  label="Cancel Disputes"
                />
                <Typography className="dispute-action-text" variant="body2" ml={3}>
                  Auction House and Buyers have resolved all issues and the buyers have paid for
                  their items.
                </Typography>
                <FormControlLabel
                  sx={{ mt: 1 }}
                  value={DISPUTES_ACTIONS.CLOSE}
                  control={<Radio size="small" />}
                  label="Close Disputes"
                />
                <Typography className="dispute-action-text" variant="body2" ml={3}>
                  Dispute must be open 4 days before it can be closed. Auction house receives a Live
                  credit, Bidder added to House's No Bid List, each bidder is granted an unpaid item
                  strike.
                </Typography>
                <Typography className="dispute-action-text" variant="subtitle2" ml={3}>
                  Please note — by closing these disputes you are agreeing to our{' '}
                  <Button className="terms-link" onClick={openTermsAndConditions}>
                    dispute terms & conditions.
                  </Button>
                </Typography>
              </>
            )}
          </>
        )}
        {showReOpenOption && (
          <Box>
            <FormControlLabel
              sx={{ mt: 1 }}
              value={DISPUTES_ACTIONS.REOPEN}
              control={<Radio size="small" />}
              label="Reopen Disputes"
            />
            <Typography className="dispute-action-text" variant="body2" ml={3}>
              Internal Super admin users only.
            </Typography>
          </Box>
        )}
      </RadioGroup>
    </FormControl>
  )
);

DisputeActionOptions.propTypes = {
  selectAction: string.isRequired,
  setSelectAction: func.isRequired,
  openTermsAndConditions: func.isRequired,
  showMessageOption: bool,
  showReOpenOption: bool,
  showCloseAndCancelOption: bool
};

DisputeActionOptions.defaultProps = {
  showMessageOption: true,
  showReOpenOption: false,
  showCloseAndCancelOption: false
};

export default DisputeActionOptions;
